import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/global.css'

const el = document.getElementById('root')
if (!el) throw new Error('missing #root mount point')

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
